import { getAspectRatioRate } from '@zappyrent/hundop';
import { cover, rem, rgba } from 'polished';
import styled from 'styled-components';

export const StyledHeader = styled.header`
  position: absolute;
  top: ${rem('16px')};
  left: ${rem('8px')};

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.l}) {
    top: ${rem('26px')};
    left: ${rem('18px')};
  }
`;

export const StyledFooter = styled.div`
  position: absolute;
  bottom: 13.5%;
  left: calc(50% + ${rem('12px')});

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.l}) {
    bottom: ${rem('76px')};
    left: calc(50% + ${rem('12px')});
  }
`;

export const StyledFooterText = styled.p`
  margin: 0;
  font-size: ${rem('16px')};
  color: ${({ theme }) => theme.colors.cross.grayson};

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.l}) {
    margin: ${rem('5px')} 0 0 0;
  }
`;

export const StyledBoxWrapper = styled.div`
  position: relative;
  display: flex;
  justify-content: space-between;
  flex-grow: 1;
  flex-wrap: wrap;
  margin: 0 ${rem('-8px')};

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.l}) {
    margin: 0 ${rem('-12px')};
  }
`;

export const StyledBox = styled.div`
  flex-basis: 50%;
  flex-shrink: 0;
  padding: 0 ${rem('8px')};

  @media screen and (max-width: ${({ theme }) => theme.breakpoints.l}) {
    &:nth-of-type(1) {
      align-self: flex-end;
    }

    &:nth-of-type(1),
    &:nth-of-type(3) {
      transform: translateY(-28vw);
    }
  }

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.l}) {
    flex-basis: 25%;
    padding: 0 ${rem('12px')};
  }
`;

export const StyledCardImage = styled.img`
  ${cover()}
  display: block;
  height: 100%;
  width: 100%;
  object-fit: cover;
  transition: transform 0.5s ease;
`;

export const StyledCardText = styled.div`
  ${cover()}
  z-index: 100;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;
  padding: ${rem('32px')} ${rem('22px')};
  color: ${({ theme }) => theme.colors.main};
  text-align: center;
  background-color: ${({ theme }) => rgba(theme.colors['tenant'].main, 0.85)};
  overflow-y: auto;
  opacity: 0;

  strong {
    margin-bottom: ${rem('8px')};
    font-size: ${rem('16px')};
    font-weight: 700;

    @media screen and (min-width: ${({ theme }) => theme.breakpoints.l}) {
      font-size: ${rem('24px')};
    }
  }

  span {
    min-height: ${rem('44px')};
    font-size: ${rem('16px')};
    font-weight: 400;

    @media screen and (min-width: ${({ theme }) => theme.breakpoints.l}) {
      font-size: ${rem('20px')};
      font-weight: 300;
    }
  }
`;

export const StyledCard = styled.div`
  position: relative;
  width: 100%;
  margin-top: ${rem('16px')};
  padding-top: ${getAspectRatioRate(164, 180)};
  border-radius: ${rem('16px')};
  overflow: hidden;
  transform: translateZ(0);

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.l}) {
    margin-top: ${rem('24px')};
    padding-top: ${getAspectRatioRate(235, 282)};
  }

  &:hover {
    ${StyledCardImage} {
      transform: scale(1.25);
    }

    ${StyledCardText} {
      opacity: 1;
    }
  }
`;

export const StyledJoinTeamBackground = styled.div`
  margin-top: ${rem('-81px')};
  display: flex;
  flex-direction: column;
  padding: ${rem('40px')} 0 ${rem('37px')} 0;
  background-color: ${({ theme }) => theme.colors.cross.ultralightGray};

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.l}) {
    margin-top: ${rem('-27px')};
    padding: ${rem('107px')} 0 ${rem('80px')} 0;
  }
`;

export const StyledJoinTeamParagraph = styled.p`
  font-size: ${rem('16px')};
  line-height: 1.4;
  text-align: center;
  color: ${({ theme }) => theme.colors.cross.grayson};
  max-width: ${rem('275px')};
  margin: ${rem('24px')} 0 ${rem('32px')} 0;

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.l}) {
    max-width: ${rem('500px')};
    margin: ${rem('22px')} 0 ${rem('42px')} 0;
  }
`;

export const StyledCtaButtonContainer = styled.div`
  width: 100%;

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.l}) {
    width: ${rem('290px')};
  }
`;

export const StyledWrapper = styled.div`
  position: relative;
  z-index: 100;
`;

export const StyledColumnPrimary = styled.div`
  @media screen and (min-width: ${({ theme }) => theme.breakpoints.l}) {
    margin-top: ${rem('402px')};
  }
`;

export const StyledColumnSecondary = styled.div`
  @media screen and (min-width: ${({ theme }) => theme.breakpoints.l}) {
    margin-top: ${rem('213px')};
  }
`;
